Vue.component('event-queue', {
  template: templates.eventQueue,
  data() {
    return {
      model: {
        hasResults: false,
        isLoading: false
      },
      cancelTokenSource: null
    }
  },
  mounted() {
    const c = this;
    c.connect();
    c.get();
  },
  beforeDestroy() {
    const c = this;

    if (c.ws) {
      c.ws.close();
    }
    
    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {

        const messageData = event.data;

        try {

          const parsedData = JSON.parse(messageData);
          if(parsedData.channelId === utils.cookies.get('channelId') && parsedData.message === 'streamer_queue_event' || parsedData.message === 'streamer_accept_event'){
            c.model.queues = [];
            c.model.isLoading = false
            c.model.hasResults = false;
            c.get();
          }

        } catch (error) {
          console.error('Error parsing message data:', error);
        }
      
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get() {
    
      const c = this;
      let data = {};

      // if (c.cancelTokenSource) {
      //   c.cancelTokenSource.cancel('Previous request canceled.');
      // }

      c.cancelTokenSource = axios.CancelToken.source();

         userService
        .getUserEventQueue()
        .then((res) => {
          c.model.isLoading = true
          c.model.hasResults = true;
          c.model.queues = res.data;
          c.model.isLoading = true;
        })
        .catch((err) => {
          setTimeout(function () {
            c.model.isLoading = true;
          }, 10000);
        });
        
    },  
    accept(data) {
      const c = this;

      let reqData = {
        id: data.id,
        twitchId: data.twitchId,
        teamName: data.teamName,
        streamerUserName: utils.cookies.get('user_login'),
        event: data.event
      };

      userService
        .acceptUserTeam(reqData)
        .then((res) => {
          c.model.queues = [];
          c.model.isLoading = false
          c.model.hasResults = false;
          console.log(res.data.status);
          if(res.data.status === 200){
         
           const messageData = {
              message: 'streamer_accept_event',
              channelId: utils.cookies.get('channelId'),
              username: data.username,
              to: data.twitchId,
              tournamentId: data.event.tournamentId
            };

            c.ws.send(JSON.stringify(messageData));
         
            utils.alert.success(res.data.message);
          }
          else{
            utils.alert.error(res.data.message);
          }
          c.get();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cancel(data) {
      const c = this;

      var result = confirm(`Are you sure you want to remove ${data.username} from the queue?`);
      console.log(data);
      if (result == true) {
        let reqData = {
          id: data.id,
          twitchId: data.twitchId,
          teamName: data.teamName,
          streamerUserName: utils.cookies.get('user_login'),
          event: data.event
        };

        userService
        .declineUserTeam(reqData)
        .then((res) => {
          c.model.queues = [];
          c.model.isLoading = false
          c.model.hasResults = false;
          if(res.data.status === 200){
         
            utils.alert.success(res.data.message);
          }
          else{
            utils.alert.error(res.data.message);
          }
          c.get();

          const messageData = {
            message: 'streamer_queue_event',
            channelId: utils.cookies.get('channelId'),
          };

          c.ws.send(JSON.stringify(messageData));
        })
      }
    },
    cardNames(cards){
      return cards.map(card => `${card.name}(${card.tier})`).join(', ');
    }
  }
});